var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
// AgendaEventTimeLog component
import React from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import axios from "axios";
import { toast } from "react-toastify";
var AgendaEventTimeLog = function (_a) {
    var event = _a.event, onDelete = _a.onDelete;
    var handleDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var answer, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    answer = confirm("Are you sure you want to delete this time log?");
                    if (!answer) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.delete("/time_logs/".concat(event.id), {
                            headers: {
                                "Content-Type": "application/json",
                            },
                        })];
                case 2:
                    response = _a.sent();
                    console.log("response", response);
                    if (response.status === 200) {
                        onDelete(response.data.message);
                        // Optionally, trigger a refresh or update the UI
                    }
                    else if (response.status === 401) {
                        toast.error(response.data.message);
                    }
                    else {
                        toast.error(response.data.message);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    toast.error("An error occurred while deleting the time log.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var startDate = new Date(event.start);
    var endDate = new Date(event.end);
    var getTimeRange = function (startDate, endDate) {
        if (endDate.getTime() <= startDate.getTime()) {
            endDate = new Date(endDate.getTime() + 24 * 60 * 60 * 1000);
        }
        var diffMs = endDate.getTime() - startDate.getTime();
        if (isNaN(diffMs)) {
            return "Invalid dates";
        }
        if (endDate)
            if (diffMs < 0) {
                return "End date is before start date";
            }
        // Calculate time components
        var diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        var diffHrs = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
        var diffSecs = Math.floor((diffMs % (1000 * 60)) / 1000);
        var result = [];
        if (diffDays > 0) {
            result.push("".concat(diffDays, "day").concat(diffDays > 1 ? "s" : ""));
        }
        if (diffHrs > 0) {
            result.push("".concat(diffHrs, "hr").concat(diffHrs > 1 ? "s" : ""));
        }
        if (diffMins > 0) {
            result.push("".concat(diffMins, "min").concat(diffMins > 1 ? "s" : ""));
        }
        if (diffSecs > 0 && result.length === 0) {
            result.push("".concat(diffSecs, "sec").concat(diffSecs > 1 ? "s" : ""));
        }
        return result.join(" ") || "0sec";
    };
    return (_jsxs("div", { className: "agenda-event", children: [_jsxs("div", { className: "event-time", children: ["Time:", startDate.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                    }), " ", "-", endDate.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                    })] }), _jsxs("div", { className: "event-details", children: [_jsxs("div", { className: "event-position", children: ["Position: ", event.title] }), _jsxs("div", { className: "event-date", children: ["Date: ", startDate.toLocaleDateString()] }), _jsxs("div", { className: "event-cost", children: [parseFloat(event.content) > 0 &&
                                _jsxs("b", { children: ["Working Hours: ", getTimeRange(startDate, endDate)] }), parseFloat(event.content) === 0 &&
                                _jsxs("b", { children: ["Lunch break: ", getTimeRange(startDate, endDate)] })] }), _jsx("div", { className: "event-cost", children: _jsxs("b", { children: ["Total Cost: $", parseFloat(event.content || "0").toFixed(2)] }) }), _jsx("div", { className: "flex justify-end", children: _jsx("button", { onClick: handleDelete, className: "flex items-center", children: _jsx(DeleteForeverIcon, { color: "error" }) }) })] })] }));
};
export default AgendaEventTimeLog;
